/* eslint-disable react/prop-types */
import React from 'react';
import PatientFilesDateSection from './PatientFilesDateSection';

const PatientFilesList = ({
    listLoading,
    showEmpty,
    canUpload,
    groupedByDate,
    previewLoadingId,
    deletingId,
    onPreview,
    onDelete,
    canDelete = true,
    requireVisit = true,
}) => (
    <div className="patient-files__panel">
        {listLoading && <div className="patient-files__loading">Loading files…</div>}

        {!listLoading && showEmpty && (
            <div className="patient-files__empty">
                <p className="patient-files__empty-title">
                    {requireVisit ? 'No files for this visit yet' : 'No files for this patient yet'}
                </p>
                <p className="patient-files__empty-text mb-0">
                    {canUpload
                        ? 'Use Upload file / Document to add PDFs or images. They will appear here grouped by date.'
                        : 'Upload is not available for this view.'}
                </p>
            </div>
        )}

        {!listLoading && !showEmpty && (
            <div className="patient-files__list">
                {groupedByDate.map(([dateKey, items]) => (
                    <PatientFilesDateSection
                        key={dateKey}
                        dateKey={dateKey}
                        items={items}
                        previewLoadingId={previewLoadingId}
                        deletingId={deletingId}
                        onPreview={onPreview}
                        onDelete={onDelete}
                        canDelete={canDelete}
                    />
                ))}
            </div>
        )}
    </div>
);

export default PatientFilesList;
